import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  getActiveBalanceZone,
  getActiveCompany,
  getAppConfigurationValue,
  BalanceZoneStoreModel,
  CompanyStoreModel
} from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ApiOperationsLogCreateMassive } from '../../model/Operations'
import { HandleBatchResponse } from '../../model/responses/batch.response'
import { EnumTipoOperacion, Operacion } from '../../..'
import { DatePeriod } from '../../../../model'
import moment from 'moment'
import { calculateGasDay } from '../../../../helpers/gasDayHelper'

export const apiCreateOrUpdateMassiveOps = async (
  nominationMassive: ApiOperationsLogCreateMassive
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Operations/CreateOrUpdateMassive`,
    nominationMassive
  ).then(response => {
    return response.data
  })
}

export const apiNominacionesGETV2 = async ({
  operationTypes,
  dateRange,
  balanceZone,
  company,
  logisticElement
}: {
  operationTypes: EnumTipoOperacion[] | null
  dateRange: Partial<DatePeriod>
  balanceZone: BalanceZoneStoreModel | undefined
  company: CompanyStoreModel | undefined
  logisticElement: number | undefined
}): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let parseStartDate: string | null = null
  let parseEndDate: string | null = null

  let parameters = `?company=${company?.id}&balanceZone=${balanceZone?.code}`

  if (dateRange.start) {
    parseStartDate = moment(calculateGasDay(dateRange.start)).format('YYYY-MM-DD')
    parameters += `&startDate=${parseStartDate}`
  }
  if (dateRange.end) {
    parseEndDate = moment(calculateGasDay(dateRange.end)).format('YYYY-MM-DD')
    parameters += `&endDate=${parseEndDate}`
  }

  let operation = `FetchOperations`

  if (logisticElement) {
    parameters += `&elemLog=${logisticElement}`
  }

  if (operationTypes && operationTypes?.length > 0) {
    parameters += `&opType=${operationTypes}`
    operation = `FetchOperationsByTypeV2`
  }

  const request = {
    startDate: dateRange.start ? parseStartDate : null,
    endDate: dateRange.end ? parseEndDate : null,
    opType: operationTypes,
    elemLog: logisticElement,
    balanceZone: balanceZone?.id,
    company: company?.id
  }

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Operations/${operation}`, request).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetBuyAndSellOperations = async ({
  operationTypes,
  startDate,
  endDate,
  registerDate,
  stateTSO,
  state,
  counterpart,
  tradeCode
}: {
  operationTypes: EnumTipoOperacion[] | null
  startDate: Date | undefined
  endDate: Date | undefined
  registerDate: Date | undefined
  stateTSO: string[] | undefined
  state: string[] | undefined
  counterpart: number[] | undefined
  tradeCode: string | undefined
}): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const balanceZone = getActiveBalanceZone()?.id
  const company = getActiveCompany()?.id

  let parseStartDate: string | null = null
  let parseEndDate: string | null = null
  let parseRegistrationDate: string | null = null

  if (startDate) {
    parseStartDate = moment(calculateGasDay(startDate)).format('YYYY-MM-DD')
  }
  if (endDate) {
    parseEndDate = moment(calculateGasDay(endDate)).format('YYYY-MM-DD')
  }
  if (registerDate) {
    parseRegistrationDate = moment(registerDate).format('YYYY-MM-D')
  }

  const request = {
    startDate: startDate ? parseStartDate : null,
    endDate: endDate ? parseEndDate : null,
    registrationDate: registerDate ? parseRegistrationDate : null,
    opType: operationTypes,
    stateTSO,
    state,
    counterpart,
    balanceZone: balanceZone!,
    company: company!,
    tradeCode
  }

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Operations/FetchOperationsBuyAndSell`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}
